module.exports = __webpack_public_path__ + "img/responsive.eeac8a03.png";